module.exports = __webpack_public_path__ + "img/select_views.a803bbf4.png";